import React, { useState } from 'react';
import { Menu, X, Phone, Mail, MapPin } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Simulador',
    href: '#simulador'
  }, {
    name: 'Comercial',
    href: '#comercial'
  }, {
    name: 'FAQ',
    href: '#faq'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <header className="fixed top-0 w-full bg-white shadow-md z-50" data-id="element-116">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-117">
        <div className="flex justify-between items-center h-20" data-id="element-118">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-119">
            <a href="#inicio" className="flex items-center gap-3" data-id="element-120">
              <img src="https://cdn.magicpatterns.com/uploads/uB3M9w8su6P2THNwnbY3ow/71e2d423-eec7-4cf1-bb5d-7f9fe5f3787f.jpg" alt="Finance Group" className="h-12 w-12 rounded-lg object-cover" data-id="element-121" />
              <span className="font-bold text-2xl text-blue-900 tracking-tight" data-id="element-122">
                FINANCE <span className="text-black" data-id="element-123">GROUP</span>
              </span>
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex space-x-6 lg:space-x-8" data-id="element-124">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-gray-700 hover:text-blue-900 font-medium text-sm transition-colors" data-id="element-125">
                {link.name}
              </a>)}
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-126">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-700 hover:text-blue-900 focus:outline-none" data-id="element-127">
              {isMenuOpen ? <X size={28} data-id="element-128" /> : <Menu size={28} data-id="element-129" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {isMenuOpen && <div className="md:hidden bg-white border-t border-gray-100 shadow-lg absolute w-full" data-id="element-130">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-131">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMenuOpen(false)} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-900 hover:bg-gray-50" data-id="element-132">
                {link.name}
              </a>)}
          </div>
        </div>}
    </header>;
}